export default Object.freeze({
  STEPS: [
    {
      target: '#v-step-0',
      content: 'この画面では日報の登録ができます。<br>登録までのガイドが必要な場合は[次へ]を押してください。<br>すぐに始める場合は[操作ガイド終了]を押してください。',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    },
    {
      target: '#v-step-1',
      content: '運行日を入力しましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'right'
      }
    },
    {
      target: '#v-step-2',
      content: 'だれが仕事をしたか入力しましょう<br>配車先及び乗務員又は傭車先を入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    },
    {
      target: '#v-step-3',
      content: 'どの車で仕事をしたか入力しましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    },
    {
      target: '#v-step-4',
      content: '顧客を入力しましょう。<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: true,
        placement: 'top'
      }
    },
    {
      target: '#v-step-7',
      content: 'どこからどこまでの作業か入力しましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    },
    {
      target: '#v-step-5',
      content: '商品に関する入力をしましょう<br>運賃は後述の運賃計算方法により以下の通り自動計算されます。<br>必要に応じて入力してください。<br>1.個建(数量)：数量×単価<br>2.個建(重量)：重量×単価<br>3.車建:単価<br><br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    },
    {
      target: '#v-step-8',
      content: '請求に関する入力をしましょう<br>入力したら[次へ]を押してください',
      params: {
        enableScrolling: true,
        placement: 'top'
      }
    },
    {
      target: '#v-step-9',
      content: '[入力した配送情報を反映]で配送情報の登録が完了です。<br>更に配送情報を追加する場合は左の[新しい配送情報を作成]を押してください。',
      params: {
        enableScrolling: false,
        placement: 'top'
      }
    },
    {
      target: '#v-step-save',
      content: '[保存する]で日報の登録が完了です。',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    }
  ]
})
